import React, { useEffect, useState } from "react";
import { Box, DialogActions, DialogContent, Grid } from "@mui/material";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import TextAreaComponent from "../../../atom/Inputs/TextArea";
import DropDownComponent from "../../../atom/Inputs/DropDown";
import {
  DialogComponent,
  IconButtonComponent,
  RadioButtonComponent,
  RadioButtonGroup,
  TextEditior,
  TimePickerComponent,
} from "../../../atom";
import { getText, setText } from "../../../../core/Constant";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import { useLocation, useParams } from "react-router-dom";
 
export const getAnswerLabel = (index) => String.fromCharCode(65 + index) + ".";

const initObj = {
  textValue: "",
  isChecked: false,
  isTextValid: false,
  isTextError: false,
};

const AdminQuestions = ({
  onClose = () => {},
  open = false,
  quizData = [],
}) => {
  const [inputCount, setInputCount] = useState(1);
  const [inputValues, setInputValues] = useState([initObj]);
  const location = useLocation();
  const param = useParams();

  const [qId, setQid] = useState(-1);

  const [question, setQuestion] = useState("");
  const [qisValid, setIsQValid] = useState(false);
  const [qIsError, setIsQError] = useState(false);
  const dispatch = useDispatch();

  const [isValidAns, setIsValidAns] = useState(false);

  const [reason, setReason] = useState("");
  const [reasonValid, setIsReasonValid] = useState(true);
  const [reasonIsError, setIsReasonError] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState(false);

  const [isCorrectAnsValid, setIsCorrectAnsValid] = useState(false);
  const [correctAnsError, setCorrectAnsError] = useState(false);

  const [subject, setSubject] = useState();
  const [category, setCategory] = useState();

  useEffect(() => {
    const id = param.id || (quizData && quizData.id);
    if (id) {
      setQid(id);
    }
  }, [param, quizData]);

  useEffect(() => {
    dispatch(Actions.questions.getSubjectList());
    dispatch(Actions.questions.getCategoryList());
  }, []);

  const categoryList = useSelector((state) =>
    state.questions.get("categoryList")
  );
  const subjectList = useSelector((state) =>
    state.questions.get("subjectList")
  );

  const addInputField = () => {
    setInputCount(inputCount + 1);
    setInputValues([...inputValues, initObj]);
  };

  const removeInputField = (index) => {
    let newInputFields = [...inputValues];
    newInputFields.splice(index, 1);
    setInputValues(newInputFields);
    setInputCount(inputCount - 1);
  };

  const handleInputChange = (index, value) => {
    const updatedValues = [...inputValues];
    const item = updatedValues[index];

    let isValid = value?.length > 0;

    updatedValues[index] = {
      ...item,
      textValue: value,
      isTextValid: value?.length > 0,
      isTextError: false,
    };

    for (const item of updatedValues) {
      isValid = item.isTextValid && isValid;
    }
    setInputValues(updatedValues);
    setIsValidAns(isValid);
  };

  const handleRadioChange = (index, value) => {
    const updatedValues = [...inputValues];

    const item = updatedValues[index];
    const isChecked = item?.isChecked;
    updatedValues[index] = {
      ...item,
      isChecked: !isChecked,
    };
    setInputValues(updatedValues);
  };

  const checkCorrectAnswer = (dataArray) => {
    let ansCount = 0;
    for (var i = 0; i < dataArray.length; i++) {
      if (dataArray[i].isChecked) {
        ansCount++;
      }
    }
    setIsCorrectAnsValid(ansCount > 0);
    setCorrectAnsError(!ansCount > 0);

    setInputValues(
      dataArray.map((item) => {
        if (!item.isTextValid) {
          return { ...item, isTextError: true };
        }
        return item;
      })
    );
    return ansCount > 0;
  };

  const onChangeQuestion = (text) => {
    setIsQError(false);
    setIsQValid(text.length > 0);
    setQuestion(text);
  };

  const onChangeReason = (text) => {
    setIsReasonError(false);
    setIsReasonValid(true);
    setReason(text);
  };

  const onFileUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
      setFileError(false);
      // Reset the input value so the same file can be selected again if needed
      e.target.value = "";
    }
  };

  const onSubjectChange = (e) => {
    const Selectedvalue = getText(e);
    setSubject(Selectedvalue);
  };

  const onCategoryChange = (e) => {
    const Selectedvalue = getText(e);
    setCategory(Selectedvalue);
  };

  const onRemoveImg = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setFileError(false);
  };

  const onClean = () => {
    // Note: Refresh is handled by ADD_QUESTION_TO_QUIZ handler after question is added
    setFiles([]);
    onChangeQuestion(setText(""));
    onChangeReason(setText(""));
    setInputValues([initObj]);
    setInputCount(1);
    onClose();
    setCorrectAnsError(false);
  };

  const onCreateQuestion = () => {
    const isValid = checkCorrectAnswer(inputValues);
    _.delay(() => onUpload(isValid), 200);
  };

  const onUpload = (isCorrectAns) => {
    if (qisValid && isValidAns && isCorrectAns && subject && category) {
      const list = inputValues.map((item) => {
        return { answer: item?.textValue, is_correct: item?.isChecked ? 1 : 0 };
      });
      const fd = new FormData();
      fd.append("category_id", category);
      fd.append("subject_id", subject);
      fd.append("question", question);
      fd.append("answers", JSON.stringify(list));
      fd.append("reason", reason || "");

      // Append multiple images
      files.forEach((file, index) => {
        fd.append("images[]", file);
      });

      const quizId = (quizData && quizData.id) || qId;
      fd.append("quiz_id", quizId);

      const re = {
        question,
        list,
        reason,
        files,
        qId,
      };

      dispatch(Actions.questions.addQuestion(fd, quizData));
      onClean();
    } else {
      if (!qisValid) {
        setIsQError(true);
      }
      if (!reasonValid) {
        setIsReasonError(true);
      }
      if (!isValidAns) {
        setInputValues(
          inputValues.map((item) => {
            if (!item.isTextValid) {
              return { ...item, isTextError: true };
            }
            return item;
          })
        );
      }
    }
  };
    
  return (
    <DialogComponent
      title={"Add Question"}
      isShowCloseButton={true}
      btntextone={"Add"}
      btntexttwo={"Cancel"}
      onclickone={onCreateQuestion}
      open={open}
      maxwidth={"lg"}
      onClose={() => {
        onClean();
      }}
    >
      <form>
        <DialogContent>
          <Box>
            <Grid container>
              <Grid xs={6} item>
                <DropDownComponent
                  isShowPlaceholder={true}
                  isShowZero={subjectList.length > 0 ? false : true}
                  initialValue="Select Main subject"
                  radius={"15px"}
                  onchange={onSubjectChange}
                  dropdownLabel="Select Subject"
                  list={subjectList}
                  selectedValue={subject}
                  fixedWidth="100%"
                />
              </Grid>
              <Grid xs={6} item>
                <DropDownComponent
                  isShowPlaceholder={true}
                  isShowZero={categoryList.length > 0 ? false : true}
                  initialValue="Select Cluster"
                  radius={"15px"}
                  onchange={onCategoryChange}
                  dropdownLabel="Select Cluster"
                  list={categoryList}
                  selectedValue={category}
                  fixedWidth="100%"
                />
              </Grid>
            </Grid>
            <Box>
              <TextEditior
                value={question}
                isError={qIsError}
                error="Please add question"
                label={"Question"}
                placeholder={"Enter question"}
                onchange={onChangeQuestion}
              />
            </Box>

            <Box className="admin-question-answers-wrap">
              <p
                style={{
                  padding: 0,
                  margin: 0,
                  color: "#4E657C",
                  fontSize: 19,
                  fontWeight: 700,
                }}
              >
                Answers
              </p>
              {inputValues?.map((item, index) => {
                const label = getAnswerLabel(index);
                return (
                  <Box
                    className="admin-question-inner-content"
                    key={index + "new_Ans"}
                  >
                    <Box p={1}>
                      <IconButtonComponent
                        onclick={() => removeInputField(index)}
                        btnType={"deleteIconbtn"}
                      />
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                      <span style={{ fontWeight: 700, marginRight: 8 }}>{label}</span>
                      <TextInputComponent
                        key={index}
                        onchange={(e) => handleInputChange(index, getText(e))}
                        placeholder="Enter answer"
                        value={item?.textValue}
                        isError={item?.isTextError}
                        error="Please add value"
                      />
                    </Box>
                    <Box sx={{ width: "fit-content" }}>
                      <RadioButtonGroup
                        checked={item.isChecked}
                        handleChange={(e) => handleRadioChange(index, e)}
                        key={index}
                        size={"large"}
                      />
                    </Box>
                  </Box>
                );
              })}
              {correctAnsError ? (
                <span style={{ color: "red" }}>Select correct answer</span>
              ) : null}

              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButtonComponent
                  title="Add Answer"
                  onclick={addInputField}
                  size={"large"}
                  fontsize={"large"}
                  btnType={"addIconbtn"}
                />
              </Box>
            </Box>

            <Box>
              <TextEditior
                value={reason}
                isError={reasonIsError}
                error="Please add reason"
                label={"Reason"}
                placeholder={"Add reason"}
                onchange={onChangeReason}
              />
            </Box>

            <Box>
              <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                <p
                  style={{
                    color: "#4E657C",
                    fontSize: 16,
                    fontWeight: 600,
                    marginBottom: 10,
                  }}
                >
                  Images
                </p>

                {/* Display selected images */}
                {files.length > 0 && (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(150px, 1fr))",
                      gap: 2,
                      marginBottom: 2,
                      padding: 1,
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    {files.map((file, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: "relative",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          padding: 1,
                          backgroundColor: "white",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            height: "120px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "hidden",
                            borderRadius: "4px",
                            backgroundColor: "#f5f5f5",
                            position: "relative",
                          }}
                        >
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Preview ${index + 1}`}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              width: "auto",
                              height: "auto",
                              objectFit: "contain",
                            }}
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              zIndex: 2,
                            }}
                          >
                            <IconButtonComponent
                              btnType="deleteIconbtn"
                              onclick={() => onRemoveImg(index)}
                            />
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            marginTop: 1,
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              fontSize: 12,
                              color: "#666",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {file.name}
                          </p>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}

                {/* File input */}
                <TextInputComponent
                  onchange={onFileUpload}
                  type={"file"}
                  label={files.length > 0 ? "Add More Images" : "Upload Images"}
                  inputProps={{ multiple: true, accept: "image/*" }}
                />
              </Box>

              {fileError ? (
                <span style={{ color: "red" }}>
                  Please upload at least one image
                </span>
              ) : null}
            </Box>
          </Box>
        </DialogContent>
      </form>
    </DialogComponent>
  );
};

export default AdminQuestions;
